import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useDispatch, useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { createDimensionDashboard } from '../service/dashboardService'
import { MultiDashboard } from '../types/MultiDashboard'
import { useDimensionDashboardsOptions } from './useDimensionDashboards'
import { setMultiPurposeDashboardActiveDashboard } from '../../../redux/pages/dashboard/multiPurposeDashboard/actions'

export const useCreateDimensionDashboard = () => {
  const dispatch = useDispatch()
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()
  const options = useDimensionDashboardsOptions()

  return useMutation({
    mutationFn: (data: Partial<MultiDashboard>) => createDimensionDashboard({ data, companyId }),
    onSuccess: newItem => {
      queryClient.setQueryData(options.queryKey, (oldItems = []) => {
        return [...oldItems, newItem]
      })
      dispatch(setMultiPurposeDashboardActiveDashboard(newItem.id))
    }
  })
}
